export default "__VITE_ASSET__bc978796__"